import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {Subscription} from 'rxjs';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractTypeSettingsService} from '../service/contract-type-settings.service';
import {ContractSettingsModel} from '../../../../models/ContractSettingsModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import * as toastr from 'toastr';
import {ProviderModel} from '../../../../models/ProviderModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-new-contract',
  templateUrl: './new-contract.component.html',
  styleUrls: ['./new-contract.component.scss']
})
export class NewContractComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;
  showRegion: boolean;
  showContract: boolean;
  showProvider: boolean;

  contractSettingsModel: ContractSettingsModel;
  regionSelect: RegionModel;
  contractSelect: ContractTypeModel;
  providerSelect: ProviderModel;
  saveRegion: Subscription;

  registerForm: FormGroup;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router,
              private contractTypeSettingsService: ContractTypeSettingsService,
              private formBuilder: FormBuilder, private loaderService: LoaderService) {
    super();

    this.showActions = false;
    this.showRegion = false;
    this.showContract = false;
    this.showProvider = false;

    this.contractSettingsModel = new ContractSettingsModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();
    this.contractSelect = new ContractTypeModel();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      regionCod: [{value: '', disabled: false}, Validators.required],
      contractCod: [{value: '', disabled: false}, Validators.required],
      providerCod: [{value: '', disabled: false}, Validators.required]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.saveRegion = this.contractTypeSettingsService.save(this.contractTypeSettingsService.baseUrl, this.contractSettingsModel)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item,unique key Region-Contract Type-Provider already exists', 'Warning');
            } else {
              toastr.success('Contract Setting was created with success', 'Success');
              this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 1}});
            }
          },
          error => {
            this.loaderService.display(false);
            toastr.error('Contract Setting was not created', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveRegion) {
      this.saveRegion.unsubscribe();
    }
  }

  getElementSelectedRegion($event) {
    this.contractSettingsModel.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      regionCod: this.regionSelect.cod
    });
  }

  getElementSelectedContract($event) {
    this.contractSettingsModel.contractType = $event.row;
    this.contractSelect = $event.row;
    this.registerForm.patchValue({
      contractCod: this.contractSelect.cod
    });
  }

  getElementSelectedProvider($event: any) {
    this.contractSettingsModel.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      providerCod: this.providerSelect.cod
    });
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleContract() {
    this.showContract = !this.showContract;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  reset() {
    this.resetRegion();
    this.resetProvider();
    this.resetContractType();
  }


  resetRegion() {
    this.registerForm.patchValue({
      regionCod: ''
    });
    this.regionSelect = new RegionModel();
  }

  resetContractType() {
    this.registerForm.patchValue({
      contractCod: ''
    });
    this.contractSelect = new ContractTypeModel();
  }

  resetProvider() {
    this.registerForm.patchValue({
      providerCod: ''
    });
    this.providerSelect = new ProviderModel();
  }

  isValidInput(value: AbstractControl) {
    if (value.value !== null) {
      if (value.value !== '' && value.valid) {
        return 'is-valid';
      } else {
        return 'is-invalid';
      }
    } else {
      return 'is-invalid';
    }
  }
}
